jQuery(($) => {
    let previousTriggerId = null;

    function setup () {
        $('.sort-by-selector select').on('change', function (e) {
            e.preventDefault();

            $('.all-ajax-list').hide();
            $('.pagination').hide();
            $('.ajax-loader').show();

            const queryStringObject = new URLSearchParams(window.location.search);

            const fieldName = $(this).attr('name');
            const fieldValue = $(this).val();

            queryStringObject.set(fieldName, fieldValue);

            const queryString = queryStringObject.toString();

            const url = `${window.location.origin}${window.location.pathname}?${queryString}`;

            previousTriggerId = this.id;

            $.ajax(url).done((response) => {
                $('#advanced-search-area').html(response);

                // re-setup the datepickers that were replaced by the line above
                $('#advanced-search-area').find('input.date-input').datepicker({
                    dateFormat: 'dd-mm-yy',
                    startDate: new Date()
                });

                setup();

                if (typeof window.history !== 'undefined') {
                    window.history.pushState(
                        { url },
                        document.title,
                        url
                    );
                }
                $('.all-ajax-list').show();
                $('.container').show();
                $('.pagination').show();
                $('.ajax-loader').hide();

                if (previousTriggerId) {
                    $(`#${previousTriggerId}`).focus();
                }
            }).fail((xhr) => {
                alert(`Error: ${xhr.responseText}`);
            });
        });
    }

    setup();
});



// WEBPACK FOOTER //
// ./src/js/app/search.js